export const MONTH_ABBREVIATIONS_BY_INDEX = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
] as const;

const MONTH_NAME_ABBREVIATIONS: Record<string, string> = {
  january: 'Jan',
  february: 'Feb',
  march: 'Mar',
  april: 'Apr',
  may: 'May',
  june: 'Jun',
  july: 'Jul',
  august: 'Aug',
  september: 'Sept',
  october: 'Oct',
  november: 'Nov',
  december: 'Dec',
  sep: 'Sept',
};

export const formatMonthName = (monthName: string): string => {
  if (!monthName) {
    return '';
  }

  const normalizedKey = monthName.trim().toLowerCase();
  const abbreviated = MONTH_NAME_ABBREVIATIONS[normalizedKey];

  if (abbreviated) {
    return abbreviated;
  }

  const normalizedMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1).toLowerCase();

  if (normalizedKey.startsWith('sept') || normalizedKey === 'sep') {
    return 'Sept';
  }

  return normalizedMonth.slice(0, 3);
};

export const getMonthAbbreviation = (monthIndex: number): string =>
  MONTH_ABBREVIATIONS_BY_INDEX[monthIndex] ?? '';

export const formatAbbreviatedMonthDay = (date: Date): string =>
  `${getMonthAbbreviation(date.getMonth())} ${date.getDate()}`;

export const parseLocalDateOnly = (dateString: string): Date | null => {
  const trimmed = dateString.trim();
  const isoMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(trimmed);

  if (isoMatch) {
    const year = Number(isoMatch[1]);
    const month = Number(isoMatch[2]);
    const day = Number(isoMatch[3]);
    const parsed = new Date(year, month - 1, day);

    if (
      parsed.getFullYear() !== year ||
      parsed.getMonth() !== month - 1 ||
      parsed.getDate() !== day
    ) {
      return null;
    }

    return parsed;
  }

  const parsed = new Date(trimmed);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatAbbreviatedMonthDayRange = (minDate: Date, maxDate: Date): string => {
  const isSameDay =
    minDate.getFullYear() === maxDate.getFullYear() &&
    minDate.getMonth() === maxDate.getMonth() &&
    minDate.getDate() === maxDate.getDate();

  if (isSameDay) {
    return formatAbbreviatedMonthDay(maxDate);
  }

  const minMonth = getMonthAbbreviation(minDate.getMonth());
  const maxMonth = getMonthAbbreviation(maxDate.getMonth());
  const minDay = minDate.getDate();
  const maxDay = maxDate.getDate();

  if (minMonth === maxMonth) {
    return `${minMonth} ${minDay}–${maxDay}`;
  }

  return `${minMonth} ${minDay}–${maxMonth} ${maxDay}`;
};
